/**
 * A homepage section heading set as two lines on desktop, the second in the
 * homepage's grey. Phones run it as one wrapping line in one colour.
 */
export const SplitHeading = ({
    first,
    second,
}: {
    first: string;
    second: string;
}) => (
    <>
        {first} <br className="max-md:hidden" />
        <span className="md:text-[#7E7C78]">{second}</span>
    </>
);
